// Polite "temporarily unavailable" notice (ServiceNotice) and the WhatsApp fallback of the checkout.
export default {
  notice: {
    "title": "Service temporairement indisponible",
    "message": "Pour le moment, {{what}} ne fonctionne pas. Nous vous prions de bien vouloir nous contacter sur WhatsApp pour confirmer votre réservation — notre équipe répond rapidement.",
    "whatsapp": "Confirmer sur WhatsApp",
    "retry": "Réessayer",
    "hint": "Nous vous prions de nous excuser pour ce désagrément.",
    "what": {
      "payment": "le paiement en ligne",
      "booking": "la réservation en ligne pour cette date",
      "seats": "la réservation en ligne de cette excursion",
      "tour": "cette page d’excursion",
      "page": "cette page",
      "generic": "ce service"
    },
    "fallback": {
      "title": "Confirmez votre réservation sur WhatsApp",
      "preflight": "Le paiement en ligne par Pix n’est pas disponible pour le moment. Pour ne pas perdre votre place, confirmez la réservation directement avec notre équipe sur WhatsApp — nous envoyons tous les détails pour vous.",
      "failed": "Le paiement en ligne n’a pas pu aboutir pour le moment. Pour garantir votre place, confirmez la réservation directement avec notre équipe sur WhatsApp — nous envoyons tous les détails pour vous.",
      "point1": "Excursion, date et participants figurent déjà dans le message",
      "point2": "Notre équipe confirme avec vous la disponibilité et le paiement",
      "point3": "Votre réservation est enregistrée avec un code",
      "cta": "Confirmer la réservation sur WhatsApp",
      "autoOpening_one": "Ouverture de WhatsApp dans {{count}} seconde…",
      "autoOpening_other": "Ouverture de WhatsApp dans {{count}} secondes…",
      "stay": "Je préfère rester ici",
      "autoCancelled": "Ouverture automatique annulée. Utilisez le bouton ci-dessous quand vous voulez.",
      "retryOnline": "Réessayer le paiement en ligne"
    }
  },
};
